import styled from 'styled-components';
import media from 'styled-media-query';
import { Carousel, Button } from 'antd';

export const Agreement = styled.div`
  height: calc(100vh - 300px);
  overflow-x: hidden;
  background-color: white;
  border: solid 1px #dcdddd;
  margin-top: 8px;

  & div {
    padding: 18px;
  }
`;

export const Container = styled.div`
  background-color: white;
  .ant-carousel {
    display: flex;
    justify-content: center;
  }
`;

export const RollingBanner = styled(Carousel)`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1300px;
  .slick-dots li {
    width: 18px;
    margin-left: 0px;
    margin-right: 0px;
    display: flex;
    justify-content: center;
  }
  .slick-dots li button {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    background-color: rgba(255, 255, 255, 0.4);
  }
  .slick-dots li.slick-active button {
    background: #fff;
  }
`;

export const CarouselButton = styled(Button)`
  &.ant-btn-circle,
  &.ant-btn-circle:focus {
    z-index: 2;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.2);
    &:hover,
    &:active {
      background-color: rgba(255, 255, 255, 1);
      svg path {
        stroke: #7d848f;
      }
    }
  }
  &.slick-arrow.slick-prev {
    left: 16px;
  }
  &.slick-arrow.slick-next {
    right: 16px;
  }
`;

export const ServiceWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 32px 40px 120px;

  & > div {
    max-width: 1300px;
  }
`;

export const Banner = styled.div`
  width: 100%;
  height: 340px;
  min-width: 1900px;
  background-size: cover;
  img {
    height: 100%;
    cursor: pointer;
  }
`;

/* CardView */

export const ServiceCardWrapper = styled.div`
  border: 1px solid #d2d6da;
  border-radius: 4px;
  width: 100%;
  height: 100%;
`;

export const CardThumbnail = styled.img`
  width: 100%;
`;

export const Logo = styled.img`
  height: 24px;
  margin-bottom: 12px;
`;

export const Icon = styled.img`
  height: 24px;
`;

export const ServiceCardContent = styled.div`
  padding: 24px 22px;
  background-color: white;
  width: 100%;
  border-radius: 4px;
  font-family: Apple SD Gothic Neo;

  .desc {
    font-weight: 500;
    font-size: 16px;
    line-height: 21.6px;
    letter-spacing: -0.04em;
    color: #6d7582;
  }
  .disabled {
    margin-top: 24px;
    width: 100%;
    border: 0;
    height: 50px;
    border-radius: 4px;
    font-family: Lato;
    font-size: 15px;
    font-weight: 400;
  }
  .marginBottom {
    height: 24px;
    margin-bottom: 12px;
    height: 24px;
  }
  .service-logo {
    height: 24px;
    margin-bottom: 12px;
    img.logo {
      height: 100%;
    }
  }
`;

export const StyledButton = styled.button<{ $status?: string }>`
  text-align: center;
  cursor: pointer;
  margin-top: 24px;
  width: 100%;
  height: 50px;
  border: 0;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;

  color: #ffffff;
  background-color: #0067ff;
`;

/* Footer */

export const FooterContainer = styled.div`
  width: 100%;
  font-family: Apple SD Gothic Neo;
  ${media.lessThan('medium')`
    padding: 20px 20px 100px 20px;
  `}

  ${media.greaterThan('medium')`
    padding: 40px 150px 80px 150px;
  `}
  border-top: solid 1px rgb(109, 117, 130, 0.1);
  bottom: 0;

  & .footer-name {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: -0.02em;
    color: #6d7582;
    padding-bottom: 8px;
  }

  & .footer-info {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.02em;
    color: #6d7582;
  }

  & .terms {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: -0.02em;
    color: #6d7582;

    & button {
      background-color: inherit;
    }
  }

  & button {
    padding: 0px;
  }

  & .fontWeight {
    font-weight: bold;
    padding-left: 3px;
  }
`;

export const TermsButton = styled.button`
  border: none;
  color: #6d7582;
  font-size: 13px;
  font-weight: 400;
  // background-color: white;
  cursor: pointer;
`;

export const ModalTitleSpan = styled.span`
  font-family: Apple SD Gothic Neo;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.02em;
  color: #6d7582;
`;

export const TermsText = styled.button`
  border: none;
  color: #6d7582;
  font-size: 13px;
  font-weight: 400;
`;

export const FooterCertTooltipTrigger = styled.button`
  border: none;
  color: #6d7582;
  font-size: 13px;
  font-weight: 800;
  border-radius: 50%;
  border: 1px solid #6d7582;
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;

export const FooterCertTooltipContent = styled.div`
  position: absolute;
  bottom: 36px;
  left: -14px;
  width: 100%;
  background: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: #7f7f7f solid 1px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-contents: flex-start;
  align-items: start;
  :after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 12px 10px 0;
    border-color: #ffffff transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: -12px;
    left: 12px;
  }
  :before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 12px 10px 0;
    border-color: #7f7f7f transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: -13px;
    left: 12px;
  }
`;

export const LoginCertTooltipContent = styled.div`
  position: absolute;
  bottom: 36px;
  left: 17px;
  width: 100%;
  background: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: #7f7f7f solid 1px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-contents: flex-start;
  align-items: start;
  :after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 12px 10px 0;
    border-color: #ffffff transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: -12px;
    left: 12px;
  }
  :before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 12px 10px 0;
    border-color: #7f7f7f transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: -13px;
    left: 12px;
  }
`;

/* SubBanner */

export const BeltBannerList = styled.div<{ $hasRolling: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: ${({ $hasRolling }) => ($hasRolling ? '32px' : '0')};
`;

export const EventBanner = styled.div`
  max-width: 1300px;
  width: 100%;

  & .banner-content {
    background-color: #eaf3ff;
    border-radius: 8px;
    max-width: 1300px;
    width: 100%;
    margin-top: 8px;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    padding: 20px 40px 20px 40px;
    height: 65px;
  }

  & .banner-desc {
    font-family: Apple SD Gothic Neo;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    margin-right: 40px;
    text-align: right;
    letter-spacing: -0.02em;
    color: #353c49;
  }

  & button {
    padding: 10px 16px;
    width: 150px;
    height: 38px;
    font-family: Apple SD Gothic Neo;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #353c49;

    & :hover {
      background: #f8f9fa;
      border: 1px solid #d9d9d9;
      color: #353c49;
    }
  }

  & .banner-title {
    font-size: 20px;
    text-align: center;
    font-style: normal;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: -0.02em;
    color: #3478f6;
  }

  & .date {
    font-weight: bold;
    font-size: 15px;
    color: #6d7582;
    line-height: 18px;
    margin: 13.5px;
  }

  & .icon {
    margin-right: 8px;
    margin-bottom: 6px;
    width: 24px;
  }
`;
